import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AccessControlService {
  private accessControlData: any[] = [];

  constructor() {}

  setAccessControlData(data: any[]): void {
    this.accessControlData = data;
  }

  canRead(subModuleName: string): boolean {
    return this.checkAccess(subModuleName, 'read');
  }

  canWrite(subModuleName: string): boolean {
    // console.log('________________',subModuleName)
    return this.checkAccess(subModuleName, 'write');
  }

  canUpdate(subModuleName: string): boolean {
    return this.checkAccess(subModuleName, 'update');
  }

  private checkAccess(subModuleName: string, accessType: string): boolean {
    // console.log(this.accessControlData, accessType,subModuleName)
    for (const module of this.accessControlData) {
      // console.log(module[accessType],module)
      const md = module.moduleEndpoint === subModuleName
      if ( md && module[accessType]  === true) {
        return true;
        }
      if (!module.subModules || module.subModules.length === false) {
        continue;
      }
      const subModule = module.subModules.find(
        (sm: any) => sm.subModuleName === subModuleName
      );
      if (subModule && subModule[accessType] === true) {
        return true;
      }
    }
    return false;
  }
}
